/**
 * AWARE Health Frontend — Application Entry Point
 *
 * Sets up:
 *  - React 19 with createRoot
 *  - React Query v5 QueryClient and QueryClientProvider
 *  - Global CSS (TailwindCSS v4 + custom tokens)
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './i18n'  // Initialize i18next before React renders
import './index.css'

// ---------------------------------------------------------------------------
// React Query client configuration
// ---------------------------------------------------------------------------
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache forecast data for 5 minutes — data updates weekly
      staleTime: 5 * 60 * 1000,
      // Retry failed requests up to 2 times
      retry: 2,
      // Don't refetch on window focus for data that rarely changes
      refetchOnWindowFocus: false,
    },
  },
})

// ---------------------------------------------------------------------------
// Mount React app
// ---------------------------------------------------------------------------
const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element #root not found in index.html')

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
